import {
    getOrganization,
    listOrganizations
} from './queries';
import {
    createOrganization,
    deleteOrganization,
    updateOrganization,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateOrganization,
    DeleteOrganization,
    GetOrganization,
    ListOrganizations,
    Organization,
    UpdateOrganization
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

// Token pagination (FNP-563): the caller passes the page cursor it was handed
// last, and gets back the items plus the cursor for the NEXT page. `nextToken`
// is opaque — never parsed, never constructed.
export const fetchRecords = async (query: {
    filter?: object;
    limit?: number;
    nextToken?: string | null;
}) => {
    const {
        filter,
        limit,
        nextToken,
    } = query;
    const response = await client.graphql<GraphQLQuery<ListOrganizations>>({
                                                                               query: listOrganizations,
                                                                               variables: {
                                                                                   filter,
                                                                                   limit,
                                                                                   nextToken,
                                                                               },
                                                                           });
    return {
        items: response.data?.listOrganizations.items ?? [],
        nextToken: response.data?.listOrganizations.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrganization>>({
                                                                             query: getOrganization,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getOrganization;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateOrganization>>({
                                                                                query: createOrganization,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createOrganization;
};

export const update = async (_id: string, record: Organization) => {
    delete record.created;
    delete record.updated;
    delete record.createdByUsername

    const response = await client.graphql<GraphQLQuery<UpdateOrganization>>({
                                                                                query: (updateOrganization),
                                                                                variables: {input: record},
                                                                            });
    return response.data?.updateOrganization;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteOrganization>>({
                                                                                query: (deleteOrganization),
                                                                                variables: {input: {id: id}},
                                                                            });
    return response.data?.deleteOrganization;
};
